<template>
    <section class="section section-members">
        <div class="container">
            <div class="row">
                <a class="target" name="target" id="board-members">&nbsp;</a>
                <h2 class="section-heading section-heading-white col-12">
                    Board Members
                </h2>
                <dl class="col-12">
                    <div v-for="member in members" v-bind:key="member.id"
                        v-on:mouseenter="hoverDisplayMemberDetails(member.id, $event)"
                        v-bind:class="[visibleMember === member.id ? 'selected' : visibleMember ? 'gray' : '']"
                        class="member row">
                        <a class="target" :id="member.id" aria-hidden="true">&nbsp;</a>
                        <dt class="col-12 col-md-6 col-lg-4 member-name">
                            <a class="" v-on:click="clickDisplayMemberDetails(member.id, $event)" href="#"
                                v-on:focus="hoverDisplayMemberDetails(member.id, $event)">
                                <h3>{{ member.name }}</h3>
                                <em>{{ member.title }}</em>
                            </a>
                        </dt>
                        <dd v-bind:class="[visibleMember === member.id ? 'visible' : '']"
                            class="member-detail hidden col-12 col-md-6 col-lg-8">
                            <p v-html="member.description"></p>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Members",
    data() {
        return {
            visibleMember: null
        }
    },
    computed: {
        members() {
            return this.$store.getters.orderedMembers;
        }
    },
    methods: {
        clickDisplayMemberDetails: function (id, ev) {
            ev.preventDefault();

            var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

            if (viewportWidth < 768) {
                setTimeout(function () {
                    document.getElementById(id).scrollIntoView();
                }, 0);
            } else {
                return false;
            }

            if (this.visibleMember === id) {
                this.visibleMember = null;
            } else {
                this.visibleMember = id;
            }
        },
        hoverDisplayMemberDetails: function (id) {
            var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

            if (viewportWidth < 768) {
                return false;
            }

            if (this.visibleMember === id) {
                this.visibleMember = null;
            } else {
                this.visibleMember = id;
            }
        },
    }
}
</script>

<style scoped>
.section-members {
    background: #C73734;
    color: #FFF;
}

.member.gray a {
    opacity: 0.9;
}

.member .member-name {
    margin-bottom: 2em;
    font-weight: normal;
}

.member .member-name a {
    color: #FFF;
}

.member a em {
    display: block;
}

.member a:hover,
.member.gray a:hover {
    opacity: 1;
}

.member a.member-name:after {
    font-family: "FontAwesome";
    content: "\f063";
    position: absolute;
    bottom: -1.5em;
}

.member.selected a.member-name:after {
    content: "\f062";
}

.member-name h3 {
    font-weight: 350;
}

.member.selected h3 {
    text-decoration: underline;
}

.member-detail {
    overflow: inherit;
    height: auto;
    display: none;
}

.member-detail a {
    opacity: 0.7;
}

.member-detail a:hover {
    text-decoration: underline;
    opacity: 1;
}

.member-detail>p {
    background-color: rgba(199, 55, 52, 0.8);
}

.member-detail.visible {
    display: block;
}

@media only screen and (min-width: 768px) {
    .member-detail {
        overflow: visible;
        height: 2em;
    }

    .member-detail>p {
        padding: 1.2em;
        max-height: 11em;
        overflow: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .member-detail>p::-webkit-scrollbar {
        display: none;
    }

    .member a.member-name:after {
        content: none;
    }

    .member.selected a.member-name:after {
        font-family: "FontAwesome";
        content: "\f061";
        position: absolute;
        right: 0;
        top: 1.5em;
    }
}

@media only screen and (min-width: 992px) {
    .member-detail>p {
        max-height: inherit;
        overflow: inherit;
    }
}

@media only screen and (min-width: 1920px) {
    .section.section-members {
        background-size: cover;
    }
}
</style>